"use strict";import{tag as e}from"../custom-tag.js";export function studyGroupsIcon({height:a=16,width:t=16,hidden:s=!1,title:r="Study groups"}={}){return e`
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width=${t}
      height=${a}
      fill="currentColor"
      viewBox="0 0 24 24"
      aria-hidden="${s?"true":"false"}"
      role="img"
      aria-label="${r}"
    >
      <mask
        id="study-groups_svg__mask0_6875_6647"
        width="20"
        height="10"
        x="2"
        y="7"
        maskUnits="userSpaceOnUse"
        style="mask-type:alpha"
      >
        <path
          fill="currentColor"
          d="M7.459 11.68a3.1 3.1 0 0 1-1.96.695c-.4 0-.789-.075-1.145-.213-.524-.206-1.157-.277-1.52.153A3.52 3.52 0 0 0 2 14.588v.927c0 .337.274.61.61.61l4.048.001c.5 0 .906-.405.906-.906 0-.735.182-1.434.5-2.05.182-.353.202-.788-.078-1.068a5 5 0 0 0-.527-.422m-1.961-.211a2.235 2.235 0 0 0 0-4.469 2.235 2.235 0 0 0 0 4.469m15.47.631a3 3 0 0 0-.18-.162c-.198-.165-.48-.143-.7-.01a3.1 3.1 0 0 1-1.607.447 3.1 3.1 0 0 1-1.372-.314c-.374-.183-.838-.232-1.13.065-.273.277-.248.707-.068 1.052a4.4 4.4 0 0 1 .504 2.042c0 .5.406.906.907.906h4.067a.61.61 0 0 0 .611-.61v-.927c0-.97-.4-1.834-1.032-2.488m-2.488-.632a2.235 2.235 0 0 0 0-4.469c-1.222 0-2.234.99-2.234 2.234a2.25 2.25 0 0 0 2.234 2.235m-3.983 1.264c-.299-.262-.738-.234-1.093-.056-.424.214-.9.33-1.415.33-.4 0-.789-.074-1.144-.213-.524-.205-1.157-.276-1.52.153a3.52 3.52 0 0 0-.835 2.273v.927c0 .337.275.61.611.61h5.817a.61.61 0 0 0 .611-.61v-.927c0-.97-.4-1.855-1.032-2.487M11.99 12.1c1.222 0 2.234-.99 2.234-2.233a2.217 2.217 0 0 0-2.235-2.213c-1.222 0-2.234.99-2.234 2.234a2.22 2.22 0 0 0 2.234 2.213"
        />
      </mask>
      <g mask="url(#study-groups_svg__mask0_6875_6647)">
        <path fill="currentColor" d="M24 0H0v24h24z" />
      </g>
    </svg>
  `}
//# sourceMappingURL=studyGroups.js.map
